
import { Component, Vue, Prop } from 'vue-property-decorator';
import echarts from 'echarts'; // 引入基本模板
import LogUtils from 'panda-log';

@Component
export default class ChartLine extends Vue {
  @Prop() private lineX!: [string];
  @Prop() private lineY!: [number];
  @Prop() private lineZ!: [number];
  private chart!: any;

  get opts() {
    return {
      tooltip: {
        trigger: 'axis',
        position: (pt: any) => [pt[0], '50%'],
        formatter: function(params: any) {
          function formatterTime(seconds: number) {
            if (seconds) {
              let h = Math.floor(seconds / 60 / 60);
              let m = Math.floor((seconds / 60) % 60);
              if (h < 1) {
                return m + '分钟';
              } else {
                return h + '小时' + m + '分钟';
              }
            } else {
              return seconds;
            }
          }

          return `
              <div style="padding:2px 10px;"><b>${params[0].axisValue}</b>
              <p style="color: #96c6f1; margin:2px 0;">总开机：${formatterTime(params[0].data)}</p>
              <p style="color: #efef02; margin-bottom:0;">总连接：${formatterTime(params[1].data)}</p></div>
            `;
        },
      },

      // 与 formatter 互斥
      // legend: {
      //   top: 20,
      //   icon: 'rect',
      //   itemWidth: 14,
      //   itemHeight: 5,
      //   itemGap: 13,
      //   data: ['总开机', '总连接'],
      //   right: '4%',
      //   textStyle: {
      //     fontSize: 12,
      //     color: 'red',
      //   },
      // },
      grid: {
        top: 10,
        right: 90,
        left: 60,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: this.lineX,
      },
      yAxis: {
        type: 'value',
        // show: false,
        axisLabel: {
          formatter(value: number) {
            if (value) {
              return (value / 3600).toFixed(0) + '小时';
            }
          },
        },
        boundaryGap: [0, '100%'],
      },

      series: [
        {
          type: 'line',
          smooth: true,
          sampling: 'average',
          areaStyle: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: 'rgba(0, 136, 212, 0.3)',
                },
                {
                  offset: 0.8,
                  color: 'rgba(0, 136, 212, 0)',
                },
              ],
              false
            ),
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 10,
          },
          itemStyle: {
            color: '#96c6f1',
          },
          data: this.lineY,
        },
        {
          type: 'line',
          smooth: true,
          sampling: 'average',
          areaStyle: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: 'rgba(219, 50, 51, 0.3)',
                },
                {
                  offset: 0.8,
                  color: 'rgba(219, 50, 51, 0)',
                },
              ],
              false
            ) as any,
            shadowColor: 'rgba(0, 0, 0, 0.1)',
            shadowBlur: 10,
          },
          itemStyle: {
            color: '#e2e232',
          },
          data: this.lineZ.map(el => el.toFixed(2)),
        },
      ],
    };
  }

  setEchart() {
    let _this = this;
    this.chart = echarts.init(this.$refs.lineChart as any);
    this.chart.setOption(_this.opts);
  }

  mounted() {
    // this.setEchart();
    // setTimeout(() => {
    //   this.setEchart();
    // }, 500);
    this.$nextTick(() => {
      this.setEchart();
      LogUtils.debug('💨', this.lineY, this.lineZ);
    });
    let _this = this;
    window.onresize = function() {
      _this.chart.resize();
    };
  }
}
